<template>
  <div class="GalleryGridBlock">
    <div class="grid-item"
         :class="gridItemClass"
         v-for="image in images"
         :key="image"
         :style="{'backgroundImage': `url('${image}')`}"></div>
  </div>
</template>

<script>
  export default {
    computed: {
      gridItemClass () {
        if (this.$vuetify.breakpoint.smAndDown || this.images.length === 1) {
          return 'grid-1-item'
        }

        if (this.$vuetify.breakpoint.mdAndDown) {
          return 'grid-2-item'
        }

        if (this.$vuetify.breakpoint.mdAndUp) {
          if (this.images.length % 2 === 0) {
            return 'grid-2-item'
          } else {
            return 'grid-3-item'
          }
        }
      },
    },

    props: {
      images: {
        required: true,
        type: Array
      }
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .GalleryGridBlock {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .grid-item {
      border-radius: 12px;
      overflow: hidden;
      background-position: center center;
      background-size: cover;
      margin: 8px;
    }

    .grid-1-item {
      min-width: calc(100% - (8px * 2));
      height: 500px;

      @media(max-width: 700px) {
        height: 200px;
      }
    }

    .grid-2-item {
      min-width: calc(100% / 2 - (8px * 2));
      height: 270px;
    }

    .grid-3-item {
      min-width: calc(100% / 3 - (8px * 2));
      height: 180px;
    }
  }
</style>
